import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageLoader } from "@/components/common/PageLoader";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const reauthBack = sessionStorage.getItem("pf_reauth");
    if (reauthBack) {
      sessionStorage.removeItem("pf_reauth");
      api.post("/auth/reauth/google", { session_id: sessionId })
        .then(() => toast.success("Confirmed with Google for 10 minutes. Repeat your action."))
        .catch((err) => toast.error(formatApiError(err)))
        .finally(() => { window.history.replaceState(null, "", location.pathname); navigate(reauthBack, { replace: true }); });
      return;
    }
    api
      .post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data);
        window.history.replaceState(null, "", location.pathname);
        navigate(location.pathname === "/" ? "/dashboard" : location.pathname, { replace: true, state: { user: data } });
      })
      .catch((err) => {
        setError(formatApiError(err));
        setUser(false);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (error)
    return (
      <div className="container-x py-24 text-center" data-testid="auth-callback-error">
        <p className="font-heading text-xl text-amber-100">Sign-in failed</p>
        <p className="mt-2 text-sm text-red-300">{error}</p>
        <button className="btn-outline mt-6" onClick={() => navigate("/login", { replace: true })} data-testid="auth-callback-retry">Back to sign in</button>
      </div>
    );
  return <PageLoader label="Opening the gates" />;
}
